module.exports = __webpack_public_path__ + "static/media/heldane-text-web-medium.5aa6f494.woff";